import csAntd from 'antd/lib/locale-provider/cs_CZ';
import enAntd from 'antd/lib/locale-provider/en_US';

import csIntl from './cs.yml';
import enIntl from './en.yml';

export const languages = ['en', 'cs'];

export const antdData = {
    cs: csAntd,
    en: enAntd,
};

export const intlMessages = {
    cs: csIntl,
    en: enIntl,
};
